/** Fixture für den Fixtures-Modus (#561) — realistische Outbound-Absender. */
export function sendersFixture() {
  const now = new Date().toISOString();
  return {
    senders: [
      {
        senderKey: 'newsletter.kunde.de', label: 'newsletter.kunde.de',
        learned: { mean: 1200, stddev: 180, maxHourly: 1500, ceiling: 1740 },
        totalMsgs: 820000, firstSeen: '2026-01-02T00:00:00Z', lastSeen: now,
        msgsThisHour: 340, msgs24h: 9800, override: null, effectiveCap: 1740,
      },
      {
        senderKey: 'shop.kunde.de', label: 'shop.kunde.de',
        learned: { mean: 40, stddev: 12, maxHourly: 90, ceiling: 90 },
        totalMsgs: 52000, firstSeen: '2026-03-01T00:00:00Z', lastSeen: now,
        msgsThisHour: 8, msgs24h: 210,
        override: { manualHourlyCap: 500, exempt: false, note: 'Saisonaler Sale freigegeben', updatedAt: now },
        effectiveCap: 500,
      },
      {
        senderKey: 'vip.kunde.de', label: 'vip.kunde.de',
        learned: { mean: 0, stddev: 0, maxHourly: 0, ceiling: 1 },
        totalMsgs: 5, firstSeen: now, lastSeen: now,
        msgsThisHour: 2, msgs24h: 2,
        override: { manualHourlyCap: null, exempt: true, note: 'Transaktionsmailer, ausgenommen', updatedAt: now },
        effectiveCap: null,
      },
    ],
  };
}
